import styled from "styled-components";

export const OnboardingDialogMainTextBox = styled.div`
    font-size: 2.6rem;
    line-height: 3rem;
    ${({theme}) => theme.font.presets.bold}
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        font-size: 2rem;
        line-height: 1.3;
    }
`;
